import React from "react";
import { useHistory } from "react-router";
import { addAnswerToSet, addItemSet, addStudentId, postAnswerSet, resetAsSliceState, setEndTime, setStartTime } from "../../../../store/AnswerSetSlice";
import { useAppDispatch, useAppSelector } from "../../../../store/Hooks";
import { Answer } from "../../../../store/viewmodels/AnswerViewModel";
import { Itemset, ItemsetResult } from "../../../../store/viewmodels/ItemsetViewModel";
import { Item } from "../../../../store/viewmodels/ItemViewModel";
import { StudentData } from "../../../../store/viewmodels/StudentViewModel";
import { Task } from "../../../../store/viewmodels/TaskViewModel";
import { getElementsByFiles } from "../../../../utils/TaskContentServices";
import { getNextUrl, postCheck } from "../../../../utils/TaskNavigationServices";
import ModalWrapper from "../../../utils/modal/ModalWrapper";
import FeedBack from "../FeedBack";
import Header from "../Header";
import OrganizeCards from "./OrganizeCards";

export interface StudentOrganizeItemProps {
    task: Task,
    itemset: Itemset,
    item: Item,
}

function StudentOrganizeItem(props: StudentOrganizeItemProps): JSX.Element {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const studentData: StudentData = useAppSelector(state => state.studentData);
    let aStartTime = new Date();
    const nextUrl = getNextUrl(props.itemset, props.item, props.task, studentData.student.active_item_sets);

    const [answerValue, setAnswer] = React.useState("");
    const [orderedItems, setOrderedItems] = React.useState([] as Item[]);
    const itemCount: number = props.item.child_items.length;
    const [isModalVisible, setModalVisible] = React.useState(false);
    const [clear, setClear] = React.useState(false);
    const [forward, setForward] = React.useState(false);

    React.useEffect(() => {
        const itemset: ItemsetResult = { id: props.itemset.id, name: props.itemset.name, type: props.itemset.type }
        dispatch(addStudentId(studentData.student.id));
        dispatch(addItemSet(itemset));
        let asStartTime = new Date();
        dispatch(setStartTime(asStartTime.toISOString()));

        return () => { }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    React.useEffect(() => {
        if (answerValue !== "") { setForward(true); }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [answerValue])

    React.useEffect(() => {
        if (orderedItems.length >= itemCount) {
            let a = "";
            for (let i: number = 0; i < orderedItems.length; i++) {
                a = a + orderedItems[i].content + ";";
            }
            setAnswer(a);
            setForward(true);
        } else {
            setForward(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orderedItems])


    const commitAnswer = () => {
        let correct = props.item.correct;

        let noFeedBack = props.task.no_feedback;
        let time = noFeedBack ? 0 : 1500;

        if (!noFeedBack) {
            let feedBack = answerValue === correct ? <FeedBack correct={true} itemId={props.item.id} /> : <FeedBack correct={false} itemId={props.item.id} />;
            setContent(feedBack);
            setModalVisible(true);
        }

        setTimeout(() => {
            history.push(nextUrl);
            setModalVisible(false);
            let answer: Answer = {} as Answer;
            let aEndTime = new Date();
            answer.item = props.item.id;
            answer.value = answerValue;
            answer.end_time = aEndTime.toISOString();
            answer.start_time = aStartTime.toISOString();
            dispatch(addAnswerToSet(answer));
            const postAnswerSetCheck: boolean = postCheck(props.itemset, props.item, props.task, studentData.student.active_item_sets);
            if (postAnswerSetCheck) {
                let asEndTime = new Date()
                dispatch(setEndTime(asEndTime.toISOString()))
                dispatch(postAnswerSet())
                    .then(() => {
                        dispatch(resetAsSliceState())
                    })
            } else {
                setOrderedItems([]);
                setForward(false);
            }
        }, time)
    }

    const [content, setContent] = React.useState(<></>);
    let isInstruction: boolean = props.item.files.length > 0 ? true : false;

    const showModal = () => {
        return;
    }

    let organizeCards = <OrganizeCards item={props.item} clear={clear} setClear={setClear} isInstruction={isInstruction} setOrderedItems={setOrderedItems} />;
    let headerRow = <Header goForward={forward} setClear={setClear} commitAnswer={commitAnswer} type={"organize"} />

    if (!isInstruction) {
        let maxWidth = props.item.child_items.length > 2 ? "max-w-3/4 xl:max-w-2/3 " : "max-w-1/2 lg:max-w-2/3 xl:max-w-1/2 "

        return (
            <div className="h-fit w-fit">
                <ModalWrapper key={"modal_" + props.item.id} isVisible={isModalVisible} onBackdropClick={showModal} content={content} type={"feedBack"} />
                <div className="h-5/6 justify-center my-auto">
                    <div className="w-full h-5/6 flex justify-center my-auto">
                        <div className={maxWidth + " items-center mx-auto"}>
                            {organizeCards}
                        </div>
                    </div>
                    <div className="h-1/6">
                        {headerRow}
                    </div>
                </div>
            </div>
        );
    }

    let instruction_maxWidth = itemCount > 2 ? "max-w-1/3 " : "sm:max-w-1/2";
    let cards_maxWidth = itemCount > 2 ? "max-w-2/3" : "sm:max-w-1/2 6xl:max-w-2/5";

    let instruction = (
        <div className="w-full flex overflow-hidden ring-4 lg:ring-8 rounded-lg ring-gray-200 mt-2">
            {getElementsByFiles(props.item)}
        </div>);

    return (
        <div className="h-fit w-fit">
            <ModalWrapper key={"modal_" + props.item.id} isVisible={isModalVisible} onBackdropClick={showModal} content={content} type={"feedBack"} />
            <div className="h-5/6">
                <div key={"OrganizeItem_" + props.item.id} className="flex m-auto h-5/6 justify-center w-full">
                    <div className={"mx-auto my-auto p-2 lg:p-4" + instruction_maxWidth}>
                        {instruction}
                    </div>
                    <div className={"mx-auto my-auto " + cards_maxWidth}>
                        {organizeCards}
                    </div>
                </div>
                <div className="h-1/6">
                    {headerRow}
                </div>
            </div>
        </div>)
}

export default StudentOrganizeItem;